import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./ForgetPassword.css";
import logo from '../../assets/images/logo.png'; 
import { ForgetPassword } from "../../Services/AccountServices";
function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [message, setMessage] = useState("");
  const [errors, setErrors] = useState({});
  const [showOtpForm, setShowOtpForm] = useState(false); // New state for OTP form
  const navigate = useNavigate();

  const validateEmail = () => {
    const errors = {};
    if (!email) {
      errors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      errors.email = "Email is invalid";
    }
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleEmailSubmit =async (e) => {
    e.preventDefault();

    if (validateEmail()) {
      await ForgetPassword(email)
      
        .then((response) => {
          setMessage(response.data);
         navigate("/reset-password")
        })
        .catch((error) => {
          setErrors({ email: "Unable to process the request. Please try again." });
          console.error(error);
        });
    }
  };

  // const handleOtpSubmit = (e) => {
  //   e.preventDefault();
    
  //   if (!otp) {
  //     setErrors({ otp: "OTP is required" });
  //     return;
  //   }

  //   const url = ""; // Replace with your OTP verification endpoint
  //   axios
  //     .post(url, { email, otp })
  //     .then((response) => {
  //       setMessage("OTP verified successfully. Redirecting to reset password...");
  //       setTimeout(() => navigate("/reset-password"), 2000); // Redirect after 2 seconds
  //     })
  //     .catch((error) => {
  //       setErrors({ otp: "Invalid OTP. Please try again." });
  //       console.error(error);
  //     });
  // };

  return (
    <div className="container-fluid body vh-100 d-flex justify-content-center align-items-center">
      <div className="row w-100 justify-content-center"> 
        <div className="text-center pt-3 pb-3">
          <img src={logo} width={220} className="h-8" alt="..." />
        </div>
        <div className="col-md-4">
          <div className="forgot-form p-4 shadow-lg">
            <h3 className="text-center mb-4" style={{ fontSize: "1.3em" }}>
              {showOtpForm ? "Enter OTP" : "Forgot Password"}
            </h3>

            {/* {!showOtpForm ? ( */}
              <form onSubmit={handleEmailSubmit}>
                <div className="form-floating mb-3">
                  <input
                    type="email"
                    id="email"
                    name="email"
                    className="form-control"
                    placeholder="Enter your registered email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                  <label htmlFor="email">Enter your registered email</label>
                </div>
                {errors.email && <p style={{ color: "red" }}>{errors.email}</p>}
                {message && <p style={{ color: "green" }}>{message}</p>}

                <button type="submit" className="btn btn-primary w-100">
                  Send OTP
                </button>
              </form>
           

            <div className="d-flex justify-content-between mt-3">
              <button
                onClick={() => navigate("/login")}
                className="btn btn-link text-primary text-decoration-none"
              >
                Back to Login?
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
